export default {
  general: {
    name: "Flow Simulation Game",
    yes: "Si",
    no: "No",
    week: "Semana",
    add: "Agregar",
    update: "Actualizar",
    close: "Cerrar",
    cancel: "Cancelar",
    search: "Buscar",
    actions: "Acciones",
    language: "Lenguaje",
    smallWeek: "S"
  },
  menu : {
    home : 'Home',
    games : 'Juegos',
    gameVersions : "Versiones de juegos",
    demandProfiles : "Perfiles de demanda",
    instructions : "Instrucciones",
    users: "Usuarios",
    params : "Parametros",
    logout : "Deconexión",
    profile: "Mi cuenta"
  },
  fields: {
    required: "Requerido"
  },
  tokens: {
    token: "Token | Tokens",
    balance: "Tienes {nbr} token | Tienes {nbr} tokens",
    title: "Tokens",
    date: "Fecha",
    orders: "Historial de pedidos de tokens",
    number: "Numero de tokens",
    cost: "Costo",
    bill: "Factura",
    status: "Estatus"
  },
  users: {
    firstname: "Nombre",
    lastname: "Apellido",
    login: "Login",
    role: "Rol",
    password: "Código",
    lang: "Lenguaje",
    passwordRule: "8 caracteres como mínimo",
    passwordConfirmation: "El código tiene que ser el mismo",
    confirmation: "Confirmación",
    listTitle: "Usuario",
    addTitle: "Agregar un usuario",
    updateTitle: "Actualizar un usuario",
    deleteConfirmation: "Está seguro que quiere eliminar {count} el usuario ? | Está seguro que quiere eliminar {count} los usuarios ?"
  },
  roles: {
    trainner: "Animador",
    admin: "Admin",
    superAdmin: "Super Admin"
  },
  demandProfiles: {
    name: "Nombre",
    type: "Tipo de profil",
    min: "Min",
    max: "Max",
    constant: "Valor constante",
    variability: "Variabilidad",
    confirmation: "Confirmación",
    customDemandsTitle: "perfil de demandas personalizadas",
    importDemandsButton: "Cargar las demandas",
    importDemandsTemplateButton: "Descargar el template excel",
    weekNumber: "Semana N°",
    demands: "Demandas",
    listTitle: "Perfiles de demanda",
    addTitle: "Agregar perfiles de demanda",
    updateTitle: "Actualizar perfiles de demanda",
    deleteConfirmation: "Está seguro que quiere eliminar {count} el perfil de la demanda ? | Está seguro que quiere eliminar {count} los perfiles de las demandas ?",
    typeList: {
      custom: "Personalizar",
      randomBetweenTwoValue: "Aleatorio entre dos variables",
      constant: "Valor constante"
    },
    variabilityHint: "EN % (ex: 20% de demandas de 10 valores entre 8 y 12)"
  },
  instructions: {
    name: "Nombre",
    addInstruction: "Agregar instrucción",
    listTitle: "Listas de instrucciones",
    addTitle: "Agregar una lista de instrucciones",
    updateTitle: "Acutalizar una lista de instrucciones",
    deleteConfirmation: "Está seguro que quiere eliminar {count} una lista de instrucciones ? | Está seguro que quiere eliminar {count} las listas de instrucciones ?"
  },
  gameVersions: {
    type: "Tipo",
    dd: "DD",
    standard: "Estándar",
    updateLogo: "actualizar el logo",
    menu: "Menu",
    params: "Params",
    style: "Estilos",
    name: "Nombre",
    colors: {
      primary: "Color primario",
      secondary: "color secundario"
    },
    maxOrder: "Pedido máximo del proveedor",
    skipInstructions: "Salta las instrucciones",
    timerActivated: "Programar el tiempo para cada dia",
    timerCount: "Definir la duración del tiempo",
    timerCountHint: "En segundos para etapa",
    storageCost: "Costo de inventario",
    delayCost: "Costo de ruptura de stock",
    weekNbrAutoCmj: "Número de semana para un cálculo de consumo promedio diario automático",
    changeBufferEveryNbrWeek: "El buffer se puede cambiar cada semana x",
    versionToDuplicate: "Duplicar la Versión del juego",
    listTitle: "Versiones de juego",
    addTitle: "Agregar una versión del juego",
    addNew: "Nueva versión",
    addFromVersion: "De una versión existente",
    updateTitle: "Actualizar la versión del juego",
    deleteConfirmation: "Está seguro que quiere eliminar {count} la versión del juego ? | Está seguro que quiere eliminar {count} las versiones del juego ?",
    flowEquationDisplayModes: {
      title: "Ecuación de flujo neto visible",
      notDisplay: "La ecuación de flujo neto no está visible",
      alreadyCalculated: "La ecuación del flujo neto está visible y pre-definida",
      show: "Completar la ecuación de flujo neto"
    },
    ddOrderPreFilled: "Rellene previamente la cantidad para pedir en modo DD"
  },
  games: {
    test: "Modo de prueba",
    favorites: "Favoritos",
    name: "Nombre",
    code: "Código",
    version: "Versión",
    createdBy: "Creado por",
    createdAt: "Creado",
    status: "Estado",
    listTitle: "Juegos",
    addTitle: "Crear un nuevo juego",
    deleteConfirmation: "Está seguro que quiere eliminar {count} el juego ? | Está seguro que quiere eliminar {count} los juegos ?",
    statusList: {
      created: "Creado",
      open: "Abierto",
      inProgress: "En curso",
      finished: "terminado"
    },
    pause: "El juego está en pausa",
    play: "El juego recomienza",
    stop: "Usted ha terminado el juego",
    start: "El juego recomienza",
    debriefOn: "Usted tiene acceso a la sesión informativa",
    debriefOff: "Ha cancelado el acceso a la sesión informativa"
  },
  inGame: {
    delete: "Elimina el juego y recupera las tokens",
    deleteConfirmation: "Estás seguro de que deseas eliminar permanentemente el juego ?",
    setPause: "Pausa",
    setPlay: "Jugar",
    endGame: "El juego ha acabado",
    reopenGame: "El juego recomienza",
    debriefOn: "Dar acceso a la sesión informativa",
    debriefOff: "Esconder la sesión informativa",
    companies: {
      playerName: "Jugador",
      companies: "Empresas",
      step: "Paso",
      assigned: "Conectado",
      ready: "Listo",
      code: "Código",
      steps: {
        clientOrder: "Ordenes de venta",
        clientShipment: "Envíos del cliente",
        supplierShimpentWaiting: "Esperando los envíos",
        board: "Tablero de control",
        supplierShipments: "Entregas de los proveedores",
        supplierOrders: "Pedidos a los proveedores",
        productionBatch: "Lanzar la producción",
        productionShipments: "Entregas de producción",
        startNewWeek: "Comienza una nueva semana",
        inProgressProduction: "Trabajo en curso",
      }
    },
    resume: {
      resume: "Resumen",
      averageOrderQuantity: "Demanda promedio al proveedor",
      averageRequestQuantity: "Demanda promedio del cliente",
      range: "Rango de demanda",
      otd: "Entrega en plazo acordado",
      delaysDepth: "Retrazo en semanas",
      averageStock: "Inventario disponible promedio",
      stockCost: "Costos de inventario",
      delayCost: "Costos de ruptura de stock",
      cost: "Costo Total",
    },
    red: "Zona Roja",
    yellow: "Zona Amarilla",
    green: "Zona verde",
    flowEquation: "Flujo neto",
    stock: "Inventario",
    buffers: "Buffers",
    orders: "Ordenes",
    costs: "Costos",
    stockRemains: "Inventario & ruptura de stock",
    shortage: "Ruptura",
    supplychainGraph: "Cadena de suministro",
    repport: "Informe PDF"
  },
  companiesSettings: {
    supplyPicture: "Figura de la cadena de aprovisionamiento",
    logo: "Logo",
    name: "Nombre",
    level: "Nivel",
    suppliers: "Proveedor(es)",
    clients: "Cliente(s)",
    leadTime: "Plazo de expedición",
    productionLeadTime: "Plazo de producción",
    initialStock: "Inventario inicial",
    firstOrder: "Pedido inicial",
    firstProduction: "Producción inicial",
    ddOn: "Modo DD activado",
    simulatedCompany: "Simulado por el sistem",
    productionCompany: "Empresa",
    assemblyMode: "Modo de montage",
    demandProfile: "Perfiles de demanda",
    confirmation: "Confirmación",
    listTitle: "Empresas",
    addTitle: "Agregar empresas",
    updateTitle: "Actualizar la empresa",
    deleteConfirmation: "Está seguro que quiere eliminar {count} la empresa ? | Está seguro que quiere eliminar {count} las empresas ?",
    updateLogo: "Actualizar el logo",
    updateSupplyPicture: "Actualizar la figura de la cadena de aprovisionamiento"
  },
  notifications: {
    users: {
      welcome : "Bienvenido ",
      sessionExpired : "Su sesión ha expirado, por favor inicie sesión de nuevo",
      getOneError: "Error mientras se creo un usuario: ",
      getAllError: "Error mientras se crearon los usuarios : ",
      add: "El usuario ha sido agregado",
      addError: "Error mientras se crea el usuario : ",
      update: "El usuario ha sido modificado",
      updateError: "Error mientras se crea el usuario: ",
      delete: "La eliminación  ha sido realizada",
      deleteError: "Error mientras se eliminan los usuarios : "
    },
    demandProfiles: {
      getOneError: "Error mientras se crean los perfiles de demanda : ",
      getAllError: "Error mientras se crean los perfiles de demanda : ",
      add: "El perfil de las demandas ha sido agregado",
      addError: "Error mientras se crearon los perfiles de demanda : ",
      update: "El perfil de demanda ha sido modificado",
      updateError: "Error mientras se crean los perfiles de demanda: ",
      delete: "La eliminación ha sido realizada",
      deleteError: "Error mientras se eliminan los perfiles de las demandas: "
    },
    gameVersions: {
      getOneError: "Error al crear la versión del juego ",
      getAllError: "Error al crear las versiones del juego : ",
      add: "La versión del juego ha sido creada",
      addError: "Error al crear la versión del juego: ",
      update: "La versión del juego ha sido modificada",
      updateError: "Error mientras se crea la versión del juego: ",
      delete: "La eliminación ha sido realizada",
      deleteError: "Error mientras se eliminan las versiones del juego : "
    },
    companiesSettings: {
      getOneError: "Error mientras se crea la empresa: ",
      getAllError: "Error mientras se crean las empresas : ",
      add: "La empresa ha sido creada",
      addError: "Error mientras se crea la empresa : ",
      update: "La empresa ha sido modificada",
      updateError: "Error mientras se actualiza la empresa : ",
      delete: "La eliminacion ha sido realizada",
      deleteError: "Error mientras se eliminan las empresas : "
    },
    games: {
      getOneError: "Error mientras se crea una partida del juego : ",
      getAllError: "Error mientras se crea la partida del juego : ",
      add: "La partida del juego ha sido creada",
      addError: "Error mientras se crea la partida del juego : ",
      update: "La partida del juego ha sido modificada",
      updateDemands: "El perfil de demanda ha sido modificado",
      updateDemandsError: "Error mientras se crea el perfil de demandas : ",
      updateError: "Error mientras se crea la partida del juego: ",
      delete: "La eliminación ha sido realizada",
      deleteError: "Error mientras se anula una partida del juego: "
    }
  },
  socketMessages: {
    playerReady : "Los enlaces siguientes estan listos : ",
    stepChange : "Los enlaces siguientes cambian de etapa: ",
    connexion : "Conexión de enlaces : ",
    clientsShipments : "El enlace siguiente entrega los pedidos a sus clientes : ",
    suppliersOrders : "El enlace siguiente ha pasado un pedido : ",
    productionBatch: "El enlace siguiente ha lanzado la producción : ",
    customerUpdate: "Actualizacion de la información del enlace : "
  }
}